<div [ngClass]="commonService.isHidden ?'':'container-fluid'">
    <div class="card-block" style="margin: 10px;">
      <div class="head-block-title">
        <div class="row">
          <div class="col-md-8">
            <span class="listHeaderText">Payment-Plan ({{paymentPlanListData?.length}})</span>
          </div>
          <div class="col-md-4 d-flex" style="justify-content: flex-end;">
            <div class="export" (click)="changeAddUpdateModalState()">
              <div class="add-actionbutton-icon"> <img src="{{addButton}}" aria-hidden="true">
              </div>
              <span class="add-actionbutton-text" (click)="changeAddUpdateModalState()"> Add </span>
            </div> &nbsp; &nbsp;
            <export [showIconOnly]="false" [data]="selectedExportData"></export>
          </div>
        </div>
      </div>
      <div class="main-field">
        <div class="main-block-content">
          <div style="height: 500px; margin: 10px;">
            <app-common-table [columnDefs]="columnDefs" [data]="paymentPlanListData"  (commonDropdownChange)="changeAddUpdateModalState($event)"  (selectedRowsChange)="onSelectedRowsChange($event)">
            </app-common-table>
            </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Card Starts for mobile screen -->
  <div class="content-area">
    <span class="listHeaderText">Payment-Plan ({{paymentPlanListData?.length}})</span>
    <div class="row subHeaderButtonDiv">
      <div class="col-md-6 export-div">
        <div class="dropdownMenu d-flex" style="margin-top: 1.5px;">
          <div class="export-actionbutton-icon">
            <img src="{{exportButton}}">
          </div>
          <span class="add-actionbutton-text dropdown-toggle"> Export</span>
          <ul class="dropdownMenu-content" style="text-align: center;top: 37px;">
            <button type="button" class="btn" data-toggle="modal" data-target=".export-modal"><span
                class="dropdownMenu-content-option"><a (click)="toggleExport('excel')">Excel</a></span></button>
            <button type="button" class="btn" data-toggle="modal" data-target=".export-modal"><span
                class="dropdownMenu-content-option"><a (click)="toggleExport('pdf')">PDF</a></span></button>
          </ul>
        </div>
      </div>
      <div class="col-md-6 d-flex" class="positioned-flex">
        <div class="closeModal" (click)="changeAddUpdateModalState(null)">
          <span class="add-actionbutton-icon"> <img src="{{addButton}}" aria-hidden="true"></span>
          <span class="add-actionbutton-text"> Add </span>
        </div>
      </div>
    </div>

    <!--Export Modal-->
    <div class="modal export-modal" [ngClass]="showExport ? 'booking-modal-show':'booking-modal-hide'" tabindex="-1"
      role="dialog" aria-labelledby="myLargeModalLabel">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <app-export-list (exportValues)="exportValues($event)" (hideModal)="hideExport()" style="height: 59vh;"
            [exportType]="exportSelectedType" [columns]="exportColumns" [dataList]="paymentPlanListData"
            [rowSelection]="'multiple'" [fileName]="clientfileName" [exportColumnKeys]="columnKeys"
            [submitButtonTitle]="'Export'" [headerName]="'Payment List'"></app-export-list>
        </div>
      </div>
    </div>
    <div class="searchtext mb-2 mr-2">
      <div class="row">
        <div class="col-md-8"></div>
        <div class="col-md-2">
          <span>
            <input type="search" class="form-control inputSearch" placeholder="Search Payment" [(ngModel)]="filterTerm">
          </span>
        </div>
      </div>
    </div>
    <div class="row row-cards-one">
      <div class="col-md-12 col-lg-3 col-xl-3">
        <div class="mycard bg1" *ngFor="let payment of paymentPlanListData | filter: filterTerm">
          <div class="left">
            <tr>
              <td>
                <b><img src="../../../../../assets/images/PaymentPlanCardIcon.svg" aria-hidden="true" style="width: 25px; height: 25px;"/>
                  <span class="ml-1">{{payment?.name}}</span></b><br>
              </td>
            </tr>
          </div>
          <div class="right d-flex align-self-center">
            <tr>
              <td>
                <div class="dropdownMenu" (click)="dropdownActonMenu(payment.id)" style="display: block;">
                  <div>
                    <img src="assets/images/Action icon red.svg" alt="">
                  </div>
                  <div class="dropdownMenu-content dropdownActionMenu" id="actionMenuContent{{payment.id}}"
                    *ngIf="ActionList" style="top: 24px; right: 0vh;">

                    <span class="dropdownMenu-content-option"
                      (click)="changeAddUpdateModalStateMobile(payment)"><img [src]="editIcon" alt="Edit Icon" class="icon-img"/>Edit</span>
                  </div>
                </div><br>
                <br>
              </td>
            </tr>
          </div>
        </div>
      </div>
    </div>
  </div>
